import { css, createGlobalStyle } from 'styled-components';

import InterEot from './assets/fonts/inter-v3-latin/inter-v3-latin-regular.eot';
import InterWoff2 from './assets/fonts/inter-v3-latin/inter-v3-latin-regular.woff2';
import InterWoff from './assets/fonts/inter-v3-latin/inter-v3-latin-regular.woff';
import InterTtf from './assets/fonts/inter-v3-latin/inter-v3-latin-regular.ttf';
import InterSvg from './assets/fonts/inter-v3-latin/inter-v3-latin-regular.svg';

const normalize = css`
  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
  }
  body {
    margin: 0;
  }
  main {
    display: block;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  a {
    background-color: transparent;
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  img {
    border-style: none;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }
  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }
  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }
  progress {
    vertical-align: baseline;
  }
  textarea {
    overflow: auto;
  }
  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  details {
    display: block;
  }
  summary {
    display: list-item;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${normalize}

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    src: url(${InterEot});
    src: local(''), url('${InterEot}?#iefix') format('embedded-opentype'),
      url('${InterWoff2}') format('woff2'),
      url('${InterWoff}') format('woff'),
      url('${InterTtf}') format('truetype'),
      url('${InterSvg}#Inter') format('svg');
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size:3.125vw;  /* 10px/320px <--- 320px design, 62.5% is the 10px/16px*/
    @media only screen and (min-width: 768px) and (orientation: portrait) {
      font-size:1.5625vw;
    }

    @media only screen and (min-width: 768px) and (orientation: landscape) {
      font-size: 0.78125vw;
    }
  }

  body,
  #root {
    height: max-content;
    font-family: "Inter";
    font-size: 1.6rem;
    line-height: 2rem;
    letter-spacing: 0.011rem;
  }

  body {
    @media only screen and (min-width: 768px) and (orientation: portrait) {
      margin: 0 auto;
      width: 50%
    }

    @media only screen and (min-width: 768px) and (orientation: landscape) {
      margin: 0 auto;
      width: 25%
    }
  }

  #root {
    background: #F7FAFC;
  }
`;

export default GlobalStyle;
